import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProjectInfoModalComponent } from './project-info-modal.component';
import { FocusSelectDirective, OpsNumberDirective } from '@ops/components';
import { TranslateModule } from '@ngx-translate/core';
import { OpsProjectStatusComponent } from '@ops/storybook';

@NgModule({
  declarations: [ProjectInfoModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    OpsNumberDirective,
    FocusSelectDirective,
    TranslateModule,
    OpsProjectStatusComponent
  ],
  exports: [ProjectInfoModalComponent],
})
export class ProjectInfoModalModule {}
